module.exports = __webpack_public_path__ + "static/media/IL.a3ea9afb.svg";